module.exports = __webpack_public_path__ + "static/img/logo-amore.a0e1205.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/logo-amore.png
// module id = WlKU
// module chunks = 0